import React, { createContext } from 'react';
import classNames from 'classnames';
import styles from './styles.module.scss';
import { Column } from './components/Column';

export const GridContext = createContext({ brikkLayout: false });

export const Grid = ({
  children,
  style,
  transparent,
  paddingTop,
  noPadding,
  brikkLayout,
  oneColumn,
  twoColumns,
  twoEqualColumns,
}) => (
  <GridContext.Provider value={{ brikkLayout, twoColumns, transparent }}>
    <div
      className={classNames(
        styles.grid,
        brikkLayout && styles.noTopPadding,
        oneColumn && styles.oneColumn,
        twoColumns && styles.twoColumns,
        twoEqualColumns && styles.twoEqualColumns,
        transparent && styles.transparent,
        paddingTop && styles.paddingTop,
        noPadding && styles.noPadding,
      )}
      style={style}
    >
      {children}
    </div>
  </GridContext.Provider>
);

Grid.Column = Column;
